import { LargeSpinner } from '@amo/core/components/loaders';
import { hameconnage } from '@amo/core/utils/functions';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import {getStepBySlug, getTitleByStep} from '../../../utils/function';
import BookingContainer from './Booking/BookingContainer';
import FooterContainer from './Footer/FooterContainer';
import HeaderContainer from './Header/HeaderContainer';
import PopinPrevious from './PopinPrevious/PopinPrevious';
import RouteStep from './RouteStep';
import HeaderLanding from './Step/Vehicule/HeaderLanding/HeaderLanding';
import {formatDataForAnalytics} from "@amo/core/utils/formatDataForAnalytics.js";

const Init = (props) => {
    const {
        step,
        indexQuestion,
        stepInit,
        questionInit,
        goTo,
        demandeRappelLoading,
        nextQuestion,
        data,
        changeValue,
        setIndexQuestion,
        utm_source,
        errorsForm,
        analyticsSetEvent,
        codePromo,
        numeroContrat,
        dejaClientLP0,
        isTarifOnePage,
    } = props;
    const [questions, setQuestions] = useState(document.getElementsByClassName('question'));
    const [showBooking, setShowBooking] = useState(false);
    const [bookingMode, setBookingMode] = useState(null);
    const [showPopinPrevious, setShowPopinPrevious] = useState(false);

    const { previousQuestion } = props;

    const handlePreviousClick = () => {
        setShowPopinPrevious(true);
    };

    const handlePopinClose = () => {
        setShowPopinPrevious(false);
        previousQuestion();
    };

    const handlePopinCallMeBack = () => {
        setShowPopinPrevious(false);
        setBookingMode('asap');
        setShowBooking(true);
    };

    const handlePopinMakeAppointment = () => {
        setShowPopinPrevious(false);
        setBookingMode('rdv');
        setShowBooking(true);
    };

    // Ouvrir automatiquement la popup si ?modal=rappeler ou ?modal=rdv dans l'URL
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const modal = params.get('modal');
        if (modal === 'rappeler') {
            setBookingMode('asap');
            setShowBooking(true);
        } else if (modal === 'rdv') {
            setBookingMode('rdv');
            setShowBooking(true);
        }
    }, []);

    useEffect(() => {
        hameconnage({ changeValue, setIndexQuestion });
        if(dejaClientLP0 && _.get(data, 'DejaClient.Adresse1') === undefined) {
            changeValue('DejaClient.Adresse1', dejaClientLP0?.Adresse1);
            changeValue('DejaClient.Adresse2', dejaClientLP0?.Adresse2);
            changeValue('DejaClient.Adresse3', dejaClientLP0?.Adresse3);
            changeValue('DejaClient.CP', dejaClientLP0?.CP);
            changeValue('DejaClient.Ville', dejaClientLP0?.Ville);
            changeValue('postalCodeCity-dejaclientcodepostal', (dejaClientLP0?.Ville ? `${dejaClientLP0?.Ville} ${dejaClientLP0?.CP}` : null));
        }
    }, []);

    useEffect(() => {
        const baseTitle = 'Demande de devis assurance deux roues - APRIL Moto';
        const stepTitle = getTitleByStep(step);
        document.title = stepTitle ? `${stepTitle} - ${baseTitle}` : baseTitle;
    }, [step]);

    useEffect(() => {
        if (data !== undefined) {
            analyticsSetEvent({
                event: 'funnelStepLoad',
                datas: {
                    'funnelStepLoad': {
                        'stepName': step < getStepBySlug('votre-tarif') || step === getStepBySlug('vos-coordonnees') ? document.getElementsByClassName('fade-in')[0]?.getElementsByClassName('question-title')[0]?.getAttribute('data-title') : getTitleByStep(step),
                        'parentStepName': step < getStepBySlug('votre-tarif') || step === getStepBySlug('vos-coordonnees') ? getTitleByStep(step) : '', //String : nom de la famille de step parente
                        'currentInfo': formatDataForAnalytics('moto', {...data, codePromo: codePromo, numeroContrat: numeroContrat}, step, indexQuestion),
                    }
                }
            });
        }
    }, [step, indexQuestion]);

    useEffect(() => {
        let listQuestion = [];

        /* retire la class fade-in à toutes les questions qui l'ont */
        _.map(document.getElementsByClassName('question'), (q) => {
            if (q.classList.contains('fade-in')) {
                q.classList.remove('fade-in');
            }
            listQuestion.push(q);
        });

        setQuestions(listQuestion);
        /* Ajoute la class fade-in à la question en cours */
        if (document.getElementsByClassName('question')[indexQuestion]) {
            document.getElementsByClassName('question')[indexQuestion].classList.add('fade-in');
        }
    }, [indexQuestion, step, data, demandeRappelLoading]);

    /* Fonction pour passer à la question suivante si btn n'est pas disabled et seulement avant l'étape tarif */
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && step < getStepBySlug('recap-gpt')) {
            // RGAA 7.3 / 12.8 : ne pas interférer avec les éléments interactifs, modales, autocompletes
            const activeTag = document.activeElement?.tagName?.toLowerCase();
            const isInInteractiveElement = ['input', 'select', 'textarea'].includes(activeTag) ||
                document.activeElement?.closest('[role="listbox"], [role="dialog"], .swal2-container');
            if (isInInteractiveElement) return;

            const question = document.getElementsByClassName('question')[indexQuestion];

            const buttons = question.querySelectorAll('button.btn.btn-primary');

            const btn = Array.from(buttons).find(button => button.textContent.trim() === 'Continuer');

            if (btn && !btn.classList.contains('disabled')) {
                nextQuestion();
            }
        }
    };


    /* useEffect qui ajoute et retire l'event listener */
    useEffect(() => {
        if (step < getStepBySlug('votre-tarif')) {
            document.querySelector('body').addEventListener('keydown', handleKeyDown);
            return () => {
                document.querySelector('body').removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [indexQuestion]);

    useEffect(() => {
        /* Redirige sur la dernière question où en était l'utilisateur, information prise depuis le localstorage */
        // attention au retour du paiement voir le comportement
        if (stepInit !== undefined && questionInit !== undefined) {
            goTo({ step: stepInit, question: questionInit });
        }
    }, [stepInit, questionInit]);

    return (
        <>
            {step === 0 && indexQuestion === 0 && utm_source !== null && <HeaderLanding {...props} />}
            <header>
                <HeaderContainer nbQuestions={questions.length} {...props} setShowBooking={setShowBooking} analyticsSetEvent={analyticsSetEvent} onPreviousClick={step === getStepBySlug('votre-tarif') ? handlePreviousClick : undefined}/>
            </header>
            {showBooking && <BookingContainer {...props} setShowBooking={setShowBooking} bookingMode={bookingMode} />}
            {showPopinPrevious && (
                <PopinPrevious
                    onClose={handlePopinClose}
                    onCallMeBack={handlePopinCallMeBack}
                    onMakeAppointment={handlePopinMakeAppointment}
                />
            )}
            <main id="main-content" aria-live="polite">
                <h1 className="visually-hidden">Assurance 2 roues - Devis en ligne</h1>
                {demandeRappelLoading ? (
                    <LargeSpinner message={'Nous enregistrons votre demande de rappel'} />
                ) : (
                    <div className={step === getStepBySlug('votre-tarif') || step === getStepBySlug('recap-gpt') ? 'container-fluid' : 'container'}>
                        <div className={'row'}>
                            <div className={`text-center col-lg-12${isTarifOnePage && step === getStepBySlug('votre-tarif') ? ' p-0' : ''}`}>
                                {data !== undefined &&
                                    RouteStep.map((route, index) => {
                                        return (
                                            <div key={index}>
                                                {step === route.step &&
                                                    route.main({
                                                        props,
                                                        other: { questions, setQuestions, id: route.slug },
                                                    })}
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                )}
            </main>
            <footer>
                <FooterContainer step={step} />
            </footer>
        </>
    );
};

export default Init;
